import React from "react";

const TONES = {
  PAID: "ok",
  IN_PROGRESS: "brand",
  PENDING: "warn",
  REJECTED: "danger",
  SETTLED: "ok",
  FAILED: "danger",
};

const StatusPill = ({ status, label }) => (
  <span className={`fin-pill fin-pill-${TONES[status] || "warn"}`}>{label || status}</span>
);

export default StatusPill;
